<template>
  <div class="theme-default">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {},
  created() {
    this.$http.get("menus/", {}, data => {
      this.$store.commit("saveMenuGroup", data.data.results);
    });
    this.$http.get("roles/", {}, data => {
      this.$store.commit("saveRoleGroup", data.data.results);
    });
    this.$http.get("structures/", {}, data => {
      this.$store.commit("saveDepartmentGroup", data.data.results);
    });

    // //页面加载时， sessionStorage -> this.$store.state
    //   if (sessionStorage.getItem("store")) {
    //     this.$store.replaceState(
    //       Object.assign(
    //         {},
    //         this.$store.state,
    //         JSON.parse(sessionStorage.getItem("store"))
    //       )
    //     );
    //   }
    //   //强制刷新前， this.$store.state  ->   sessionStorage
    //   window.addEventListener("beforeunload", () => {
    //     sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    //   });
  }
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
  width: 100%;
  overflow-x: auto;
}
.theme-default {
  min-width: 1600px;
  height: 100%;
}
</style>
